import { AxiosResponse } from 'axios';
import { axiosClient } from '@nx-frontend/shared/api';
import { assertServiceHost } from '@nx-frontend/shared/api/services/util';
import { PortalServiceChangeEventDto, ServicePayload } from '@nx-frontend/shared/types';

export interface CreatePortalPayload extends ServicePayload {
  secret: string;
  workspaceId: string;
  portalDomain: string;
  changeEvents: PortalServiceChangeEventDto[];
  templatePortalId?: string;
  timeout?: number;
  portalName?: string;
  portalType?: string;
  pageIdOverrides?: {
    [key: string]: string;
  };
}

export async function postSetupPortalInternalApi({
  host,
  userId,
  secret,
  timeout,
  ...restProps
}: CreatePortalPayload): Promise<AxiosResponse['data']> {
  const response = await axiosClient.post(
    `${assertServiceHost(host)}/v1/setup`,
    {
      ...restProps,
    },
    {
      params: timeout ? { timeout } : undefined,
      userId,
      secret,
    }
  );

  console.log(response);

  return response.data;
}
